import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx } from "vue"

import { useField } from 'vee-validate';
import { toRef } from 'vue';
import type { Maybe } from '@/types';

type Props = {
    labels?: { value: number; label: string }[];
    rules?: string;
    name: string;
    modelValue?: Maybe<number>;
    label?: string;
    required?: boolean;
    labelFontWeight?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'RadioGroup',
  props: {
    labels: { default: () => [] },
    rules: { default: '' },
    name: {},
    modelValue: { default: null },
    label: { default: '' },
    required: { type: Boolean },
    labelFontWeight: { default: 'bold' }
  },
  setup(__props: any) {

const props = __props;

const rulesRef = toRef(props, 'rules');

const { value, errorMessage } = useField(() => props.name, rulesRef, {
    syncVModel: true
});

return (_ctx: any,_cache: any) => {
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!

  return (_openBlock(), _createBlock(_component_v_radio_group, {
    modelValue: _unref(value),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
    "error-messages": _unref(errorMessage),
    class: "mt-0"
  }, {
    label: _withCtx(() => [
      _createElementVNode("p", {
        class: _normalizeClass(["f-20 text-wrap", [{
          'prepend-required': _ctx.required,
        }, 'font-weight-' + _ctx.labelFontWeight
        ]])
      }, _toDisplayString(_ctx.label), 3)
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labels, (item, index) => {
        return (_openBlock(), _createBlock(_component_v_radio, {
          key: index,
          value: item.value,
          label: item.label,
          color: "szViolet",
          error: !!_unref(errorMessage)
        }, null, 8, ["value", "label", "error"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "error-messages"]))
}
}

})